import React, { useState } from 'react';
import { Container, Card, Button, Spinner, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import useToken from '../../hooks/useToken';
import useProgressRedirect from '../../hooks/useProgressRedirect';

export default function FollowUpConsent() {
  const { getValidToken } = useToken();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError]           = useState('');

  useProgressRedirect('FOLLOW_UP');

  const handleChoice = async (willing) => {
    setSubmitting(true);
    setError('');
    try {
      const auth = await getValidToken();
      const res = await fetch('/api/player/interview-consent', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${auth}` },
        body: JSON.stringify({ willing }),
      });
      if (res.ok) {
        navigate('/thank-you', { replace: true });
      } else {
        const d = await res.json();
        setError(d.message || 'Failed to record response');
        setSubmitting(false);
      }
    } catch {
      setError('Network error — please try again');
      setSubmitting(false);
    }
  };

  return (
    <Container className="py-5" style={{ maxWidth: 680 }}>
      <Card className="shadow p-4 p-md-5">
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>🎙️</div>
          <h2 style={{ fontWeight: 700, marginBottom: 8 }}>Optional Follow-Up Interview</h2>
          <p className="text-muted" style={{ fontSize: 15, lineHeight: 1.65, marginBottom: 0 }}>
            You have completed the study. Thank you for your participation!
          </p>
        </div>

        <div style={{
          background: '#f8f9fa', borderRadius: 10,
          padding: '20px 24px', marginBottom: 28,
          borderLeft: '4px solid #6366f1',
        }}>
          <p style={{ marginBottom: 10, fontSize: 15, lineHeight: 1.7 }}>
            We are inviting participants to take part in an optional follow-up interview.
            The interview will cover your experience in greater depth — including your testing
            approach and how you used the documentation provided during the experiment.
          </p>
          <p style={{ marginBottom: 10, fontSize: 15, lineHeight: 1.7 }}>
            Participants who volunteer will be <strong>contacted via email</strong> to schedule
            a convenient time.
          </p>
          <p style={{ marginBottom: 0, fontSize: 14, color: '#555' }}>
            ⏱ Estimated duration: <strong>30–45 minutes</strong>
          </p>
        </div>

        <p style={{ fontWeight: 600, fontSize: 15, marginBottom: 16, textAlign: 'center' }}>
          Are you willing to participate in the follow-up interview?
        </p>

        {error && <Alert variant="danger" className="mb-3">{error}</Alert>}

        <div style={{ display: 'flex', gap: 16, justifyContent: 'center' }}>
          <Button
            variant="success"
            size="lg"
            disabled={submitting}
            onClick={() => handleChoice(true)}
            style={{ minWidth: 200, fontWeight: 600, fontSize: 16 }}
          >
            {submitting ? <Spinner animation="border" size="sm" /> : null}
            {!submitting && "Yes, I’m willing"}
          </Button>
          <Button
            variant="outline-secondary"
            size="lg"
            disabled={submitting}
            onClick={() => handleChoice(false)}
            style={{ minWidth: 200, fontWeight: 600, fontSize: 16 }}
          >
            {submitting ? <Spinner animation="border" size="sm" /> : null}
            {!submitting && 'No, thank you'}
          </Button>
        </div>

        <p className="text-muted text-center mt-4" style={{ fontSize: 12 }}>
          Your choice will not affect the validity of your study participation.
        </p>
      </Card>
    </Container>
  );
}
